import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaTransactionsMenuRegistry = {
    personalize_nebulaTransactions: {
        label: "Nebula Transactions",
        link: PAGE_URL.NEBULA_TRANSACTIONS_PAGE,
        key: PAGE_URL.NEBULA_TRANSACTIONS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaTransactionsMenuRegistry;
